import { useQuery } from 'react-query';
import getOperations from 'data/requests/getOperations';
import { Operations } from 'model/operations';

type Props = {
  brandId: string;
  integration: string;
  dateStart: String;
  dateEnd: string;
};

const useOperations = ({ brandId, integration, dateStart, dateEnd }: Props) => {
  const { data, isLoading, refetch } = useQuery<Operations>(
    [
      'operations',
      {
        brandId,
        integration,
        dateStart,
        dateEnd,
      },
    ],
    () => getOperations({ brandId, integration, dateStart, dateEnd }),
    {
      enabled: false,
    },
  );
  return { operations: data, isLoading, refetch };
};

export default useOperations;
